import React from 'react';
import { useDispatch } from 'react-redux';

import SelectSizeCategory from '@components/SelectSizeCategory';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { increaseSizeCategorySequence } from '@services/measurementService';

const AddSizeModal = ({
	item,
	setIsAddSize,
	stylesData,
	addDesignIndex,
	setOrderStyles,
	isFromCreateOrder,
	disabled
}) => {
	const dispatch = useDispatch();
	const onAddSize = async (item, payload) => {
		if (item) {
			try {
				const newData = [...stylesData];

				const selectedDesign = newData.find((ite) => ite.id === addDesignIndex);
				if (payload !== undefined) {
					if (!([payload.sizeCategoryId] in selectedDesign.sizeCategorySequenceMap)) {
						dispatch(openLoader());
						const data = await increaseSizeCategorySequence(
							payload.productId,
							payload.sizeCategoryId,
							'PP_SAMPLE'
						);
						selectedDesign.sizeCategorySequenceMap = data;
						dispatch(closeLoader());
					}

					let prevColorWiseSizes = selectedDesign.colorWiseSizeQuantityPairList;
					let newColorWiseSizes = payload.colorWiseSizeQuantityPairList;

					let colorWiseSizeObj = {};
					for (let prevColor of prevColorWiseSizes) {
						for (let prevSize of prevColor.sizeQuantityPairList) {
							colorWiseSizeObj[`${prevColor.id}_${prevSize.id}`] = prevSize.quantity;
						}
					}

					for (let newColor of newColorWiseSizes) {
						for (let newSize of newColor.sizeQuantityPairList) {
							newSize.quantity = colorWiseSizeObj[`${newColor.id}_${newSize.id}`] || 0;
						}
					}
					let prevIds = prevColorWiseSizes.map((item) => item.id);
					// selectedDesign.allSizeResponseList = payload.allSizeResponseList;
					selectedDesign.sizeCategoryResponse = payload.sizeCategoryResponse;
					selectedDesign.colorWiseSizeQuantityPairList = newColorWiseSizes.filter((item) =>
						prevIds.includes(item.id)
					);
					selectedDesign.sizeQuantityPairList = payload.sizeQuantityPairList;
					selectedDesign.sizeCategoryId = payload.sizeCategoryId;
				} else {
					selectedDesign.colorWiseSizeQuantityPairList.map((value) => {
						value.sizeQuantityPairList = [
							...value.sizeQuantityPairList,
							{ label: item.value, id: item.id, quantity: 0 }
						];
					});
				}
				setOrderStyles(newData);
				//	onClosePopups();
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	const onRemoveSize = (sizeId) => {
		let newData = JSON.parse(JSON.stringify(stylesData));
		newData[addDesignIndex].colorWiseSizeQuantityPairList.map((value) => {
			value.sizeQuantityPairList = value.sizeQuantityPairList.filter((item) => item.id !== sizeId);
			return value;
		});
		setOrderStyles(newData);
	};

	return (
		<SelectSizeCategory
			productId={item.productId}
			selectedItem={item}
			setIsAddSize={setIsAddSize}
			onAddSize={onAddSize}
			onRemoveSize={onRemoveSize}
			isFromCreateOrder={isFromCreateOrder}
			disabled={disabled}
		/>
	);
};

export default AddSizeModal;
